export default __webpack_public_path__ + "static/media/006-sweater.fc79bec5.svg";